/**
 * Entry-key validation for the /docs router (pure; no window access).
 *
 * A URL segment is accepted as a wiki entry key only when it has the
 * sxwiki_entries key shape, so a hostile value never reaches the DOM or a
 * selector; the page then resolves it against the loaded entries and shows
 * the "ni zapisa" notice for anything unknown.
 */

const WIKI_KEY_RE = /^[a-z0-9][a-z0-9_-]{0,63}$/;

/** Returns the key when it has the entry-key shape, else null. */
export function parseWikiKey(raw: string | null | undefined): string | null {
  if (typeof raw !== 'string') return null;
  const key = raw.trim();
  return WIKI_KEY_RE.test(key) ? key : null;
}
